
import Vue from 'vue';
import Touchy from '@/extensions/libs/Touchy'

/**
 * # v-move-to
 * 
 * Move $element to `#move-to` DIV or `body`.
 * 
 * Fixes scroll-bug on iOS devices with `position: fixed` elements:
 * Elements need to be attached directly to `body` or they will flicker
 * during scrolling.
 * 
 * ```
 * <div v-move-to class="">...</div>
 * <div v-move-to="`body`" class="">...</div>
 * <div v-move-to="`outer-space`" class="">...</div>
 * <div v-move-to="`upper-space`" class="">...</div>
 * ```
 * @class extensions_directives_move-to
 */
Vue.directive('move-to', {
	
	isFn: true,

	inserted( $el, binding, vnode ) {
		var target = binding.value || 'outer-space';
		if (target == 'body') {
			document.body.appendChild( $el );
		} else {
			document.getElementById( target ).appendChild( $el );
		}
	},

	unbind( $el ) {
		if (!$el.parentNode) return false;
		setTimeout(() => {
			if ($el.parentNode) {
				$el.parentNode.removeChild( $el );
			}
		}, 500);
	}



})
